// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Euhm","top":"styles_top__2kYYc"};